import { useContext, useEffect, useState } from 'react'
import { UGEContext } from '../../context'
import { ugeStickerCategories } from '../../types'
import Grid from './grid'
import { Checkerboard } from './style'
import Toolbar from './toolbar'

type Props = {
    className?: string
}

const UGEStickersEditor = ({ className }: Props) => {
    const { activeEditorProps, resetEditorProps } = useContext(UGEContext)
    const [searchTerm, setSearchTerm] = useState<string>(activeEditorProps?.searchTerm || ugeStickerCategories[0])

    useEffect(() => {
        if (activeEditorProps?.searchTerm) {
            setSearchTerm(activeEditorProps.searchTerm)
            resetEditorProps()
        }
    }, [activeEditorProps?.searchTerm])

    return (
        <Checkerboard className={className}>
            <Toolbar searchTerm={searchTerm} onSearch={setSearchTerm} />
            <Grid searchTerm={searchTerm} />
        </Checkerboard>
    )
}

export default UGEStickersEditor
